import React from "react";
import { FaInstagram, FaLinkedin } from "react-icons/fa";

function Footer() {
  return (
    <div className="bg-gray-100 py-10 font-sans text-white">
      <div className="container mx-auto px-4 md:px-0">
        <div className="mb-6 flex flex-wrap justify-between border-b border-gray-600 pb-6">
          <div className="mb-6 w-full sm:w-1/2 md:w-1/4">
            <h2 className="mb-4 font-bold">Kontakte</h2>
            <p className="text-gray-400">
              Email:{" "}
              <a
                href="mailto:info@nidesso.ch"
                className="text-gray-400 hover:text-[#FE9456]"
              >
                info@nidesso.ch
              </a>
            </p>
            <p className="text-gray-400">
              Telefon:{" "}
              <a
                href="tel:0799332014"
                className="text-gray-400 hover:text-[#FE9456]"
              >
                079 933 20 14
              </a>
            </p>
          </div>
          <div className="mb-6 w-full sm:w-1/2 md:w-1/4">
            <h2 className="mb-4 font-bold">Unternehmen</h2>
            <p>
              <a
                href="/about-us"
                className="text-gray-400 hover:text-[#FE9456]"
              >
                Über Uns
              </a>
            </p>
            <p>
              <a
                href="https://www.youtube.com/watch?v=J3mbDanfoQQ"
                className="text-gray-400 hover:text-[#FE9456]"
              >
                Swiss Startup Challenge
              </a>
            </p>
          </div>
          <div className="mb-6 w-full sm:w-1/2 md:w-1/4">
            <h2 className="mb-4 font-bold">Social Media</h2>
            <div className="flex space-x-4">
              <a
                href="https://www.instagram.com/nidesso.ch/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="text-2xl text-gray-400 hover:text-[#FE9456]" />
              </a>
              <a
                href="https://linkedin.com/company/nidesso"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="text-2xl text-gray-400 hover:text-[#FE9456]" />
              </a>
            </div>
          </div>
        </div>
        <div className="flex justify-between text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Copyright © Nidesso 2024</p>
          <div className="flex space-x-4">
            <a
              href="/docs/Datenschutz_Nidesso.pdf"
              rel="noopener noreferrer"
              className="hover:text-[#FE9456]"
            >
              Datenschutz
            </a>
            <a
              href="/docs/AGB_Nidesso.pdf"
              rel="noopener noreferrer"
              className="hover:text-[#FE9456]"
            >
              AGB
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
